module.exports = __webpack_public_path__ + "images/speed-four-active.5eb930ce84eb0ff88bcc7933d13ada15.png";